export interface Creative {
  id: string;
  meta_creative_id: string;
  meta_account_id: string;
  creative_type: string;
  filename: string;
  dimensions: string | null;
  thumbnail_url: string | null;
  thumbnail_path: string | null;
  uploaded_at: string | null;
  aspect_ratio: string | null;
  group_type: string | null;
  group_id: string | null;
  tags: Record<string, string> | null;
}

export function calculateAspectRatioLabel(dimensions: string | null): string {
  if (!dimensions) return 'Other';

  const parts = dimensions.split('x').map(Number);
  if (parts.length !== 2 || !parts[0] || !parts[1]) return 'Other';

  const [width, height] = parts;
  const ratio = width / height;
  const tolerance = 0.02;

  if (Math.abs(ratio - 1) < tolerance) return '1:1 (Square)';
  if (Math.abs(ratio - (9/16)) < tolerance) return '9:16 (Vertical)';
  if (Math.abs(ratio - (4/5)) < tolerance) return '4:5';
  if (Math.abs(ratio - (16/9)) < tolerance) return '16:9';
  if (Math.abs(ratio - 1.91) < tolerance) return '1.91:1 (Link)';

  return 'Other';
}
